module.exports = __webpack_public_path__ + "img/j.7ee51499.jpg";